import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container hero-grid" }
const _hoisted_3 = { class: "hero-copy" }
const _hoisted_4 = { class: "hero-actions" }
const _hoisted_5 = { class: "trust-row" }
const _hoisted_6 = { class: "hero-visual" }
const _hoisted_7 = { class: "address-chip" }
const _hoisted_8 = { class: "quick-info" }
const _hoisted_9 = { class: "container quick-grid" }
const _hoisted_10 = { class: "section" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "home-features" }

import {
  ArrowRight,
  PhoneCall,
  Check,
  ChevronRight,
  Clock3,
  MapPin,
  Phone,
  ShieldCheck,
  Sparkles,
  Stethoscope
} from 'lucide-vue-next'
export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "eyebrow" }, "Ihre Zahnarztpraxis in Musterstadt", -1)),
          _cache[6] || (_cache[6] = _createElementVNode("h1", null, [
            _createTextVNode("Gesunde Zähne."),
            _createElementVNode("br"),
            _createElementVNode("em", null, "Ein gutes Gefühl.")
          ], -1)),
          _cache[7] || (_cache[7] = _createElementVNode("p", null, "Moderne Zahnmedizin mit Erfahrung, Sorgfalt und einem offenen Ohr – für Ihre langfristige Mundgesundheit und ein natürlich schönes Lächeln.", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(PhoneCall)),
            _cache[1] || (_cache[1] = _createTextVNode(" 030 12345670 ", -1)),
            _createVNode(_component_router_link, {
              to: "/leistungen",
              class: "text-link"
            }, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createTextVNode("Leistungen entdecken ", -1)),
                _createVNode(_unref(ArrowRight))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[2] || (_cache[2] = _createTextVNode(" Persönliche Betreuung", -1))
            ]),
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[3] || (_cache[3] = _createTextVNode(" Moderne Methoden", -1))
            ]),
            _createElementVNode("span", null, [
              _createVNode(_unref(Check)),
              _cache[4] || (_cache[4] = _createTextVNode(" Zentrale Lage", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "visual-card" }, [
            _createElementVNode("strong", null, "Für Sie da"),
            _createElementVNode("small", null, "Kompetent. Persönlich. Nah.")
          ], -1)),
          _cache[10] || (_cache[10] = _createElementVNode("div", {
            class: "tooth-art",
            "aria-hidden": "true"
          }, [
            _createElementVNode("svg", {
              viewBox: "0 0 300 360",
              role: "img"
            }, [
              _createElementVNode("defs", null, [
                _createElementVNode("linearGradient", {
                  id: "toothFill",
                  x1: "0",
                  y1: "0",
                  x2: "1",
                  y2: "1"
                }, [
                  _createElementVNode("stop", {
                    offset: "0",
                    "stop-color": "#ffffff"
                  }),
                  _createElementVNode("stop", {
                    offset: "0.58",
                    "stop-color": "#f2fbff"
                  }),
                  _createElementVNode("stop", {
                    offset: "1",
                    "stop-color": "#d9edf7"
                  })
                ]),
                _createElementVNode("linearGradient", {
                  id: "toothEdge",
                  x1: "0",
                  y1: "0",
                  x2: "0",
                  y2: "1"
                }, [
                  _createElementVNode("stop", {
                    "stop-color": "#ffffff",
                    "stop-opacity": ".9"
                  }),
                  _createElementVNode("stop", {
                    offset: "1",
                    "stop-color": "#b9dce9",
                    "stop-opacity": ".55"
                  })
                ]),
                _createElementVNode("filter", {
                  id: "toothShadow",
                  x: "-30%",
                  y: "-20%",
                  width: "160%",
                  height: "170%"
                }, [
                  _createElementVNode("feDropShadow", {
                    dx: "0",
                    dy: "22",
                    stdDeviation: "18",
                    "flood-color": "#0b426a",
                    "flood-opacity": ".24"
                  })
                ])
              ]),
              _createElementVNode("path", {
                class: "tooth-shape",
                filter: "url(#toothShadow)",
                d: "M63 45C82 21 113 24 150 42c37-18 68-21 87 3 25 31 12 83-4 119-12 28-17 58-22 93-8 58-20 86-40 86-23 0-9-87-21-87s2 87-21 87c-20 0-32-28-40-86-5-35-10-65-22-93C51 128 38 76 63 45Z"
              }),
              _createElementVNode("path", {
                class: "tooth-highlight",
                d: "M78 62c16-18 38-14 61-4-34 13-47 42-46 76-14-28-26-54-15-72Z"
              }),
              _createElementVNode("path", {
                class: "tooth-groove",
                d: "M119 61c20 10 42 10 62 0"
              }),
              _createElementVNode("path", {
                class: "tooth-root-line",
                d: "M150 255c-5-32-4-57 2-75"
              }),
              _createElementVNode("circle", {
                cx: "222",
                cy: "73",
                r: "7",
                fill: "#ffffff",
                opacity: ".88"
              }),
              _createElementVNode("path", {
                d: "M222 56v34M205 73h34",
                stroke: "#fff",
                "stroke-width": "3",
                "stroke-linecap": "round",
                opacity: ".7"
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(MapPin)),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, [
              _createElementVNode("strong", null, "Parkallee 12"),
              _createElementVNode("small", null, "12345 Musterstadt")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _createVNode(_unref(Phone)),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, [
            _createElementVNode("small", null, "Terminvereinbarung"),
            _createElementVNode("strong", null, "030 12345670")
          ], -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(Clock3)),
          _cache[12] || (_cache[12] = _createElementVNode("span", null, [
            _createElementVNode("small", null, "Öffnungszeiten"),
            _createElementVNode("strong", null, "Mo–Do 8–18 Uhr")
          ], -1))
        ]),
        _createElementVNode("div", null, [
          _createVNode(_unref(MapPin)),
          _cache[13] || (_cache[13] = _createElementVNode("span", null, [
            _createElementVNode("small", null, "Mitten in Musterstadt"),
            _createElementVNode("strong", null, "Parkallee 12")
          ], -1))
        ]),
        _createVNode(_component_router_link, { to: "/kontakt" }, {
          default: _withCtx(() => [
            _cache[14] || (_cache[14] = _createTextVNode("Alle Kontaktdaten ", -1)),
            _createVNode(_unref(ChevronRight))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[24] || (_cache[24] = _createElementVNode("div", { class: "section-heading" }, [
          _createElementVNode("div", null, [
            _createElementVNode("span", { class: "eyebrow" }, "Zahnmedizin mit Weitblick"),
            _createElementVNode("h2", null, [
              _createTextVNode("Gesundheit beginnt"),
              _createElementVNode("br"),
              _createTextVNode("mit Vertrauen.")
            ])
          ]),
          _createElementVNode("p", null, "Wir verbinden langjährige Erfahrung mit modernen Behandlungskonzepten. Dabei nehmen wir uns Zeit, erklären verständlich und entwickeln gemeinsam die passende Lösung.")
        ], -1)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_router_link, { to: "/leistungen" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ShieldCheck)),
              _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Vorsorge & Erhalt", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("p", null, "Damit Ihre eigenen Zähne möglichst lange gesund bleiben.", -1)),
              _createElementVNode("span", null, [
                _cache[15] || (_cache[15] = _createTextVNode("Zu den Leistungen ", -1)),
                _createVNode(_unref(ArrowRight))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/leistungen" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Sparkles)),
              _cache[19] || (_cache[19] = _createElementVNode("h3", null, "Ästhetik & Zahnersatz", -1)),
              _cache[20] || (_cache[20] = _createElementVNode("p", null, "Natürlich schöne und funktionell überzeugende Ergebnisse.", -1)),
              _createElementVNode("span", null, [
                _cache[18] || (_cache[18] = _createTextVNode("Mehr erfahren ", -1)),
                _createVNode(_unref(ArrowRight))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/praxis" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Stethoscope)),
              _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Persönlich behandelt", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("p", null, "Fachlich fundiert und menschlich gut aufgehoben.", -1)),
              _createElementVNode("span", null, [
                _cache[21] || (_cache[21] = _createTextVNode("Unsere Praxis ", -1)),
                _createVNode(_unref(ArrowRight))
              ])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("section", { class: "home-cta" }, [
      _createElementVNode("div", { class: "container" }, [
        _createElementVNode("div", null, [
          _createElementVNode("span", { class: "eyebrow light" }, "Willkommen am Stadtpark"),
          _createElementVNode("h2", null, "Wir freuen uns auf Ihren Besuch.")
        ])
      ])
    ], -1))
  ]))
}
}

})